import React from "react";

import { useSelector } from "react-redux";

import { Autocomplete } from "components/Form/FormikControls";

import { selectLivestockSaleConsignmentOptions } from "selectors";

const sortByVendorName = options =>
  options.sort((a, b) => a.vendorName?.localeCompare(b.vendorName));

export const ConsignmentAwareConsignmentField = ({
  name,
  label,
  onClickCreateConsignment,
  readOnly,
}) => {
  const options = useSelector(selectLivestockSaleConsignmentOptions);

  const handleNew = () => {
    onClickCreateConsignment();
  };

  const getOptionLabel = o => {
    return o.label || "Add New";
  };

  const getOptionSelected = (option, selectedOption) =>
    option?.value === selectedOption?.value;

  return (
    <Autocomplete
      name={name}
      selectOnFocus
      handleHomeEndKeys
      label={label}
      options={sortByVendorName(options)}
      getOptionValue={o => o?.value}
      groupBy={option => option.vendorName}
      getOptionLabel={options => getOptionLabel(options)}
      getOptionSelected={getOptionSelected}
      handleNew={handleNew}
      disabled={readOnly}
    />
  );
};
